type CookieOptions = {
  path?: string;
  sameSite?: "Lax" | "Strict" | "None";
  maxAgeSeconds?: number;
  secure?: boolean;
};

export function setClientCookie(name: string, value: string, options: CookieOptions = {}) {
  if (typeof document === "undefined") {
    return;
  }

  const path = options.path ?? "/";
  const sameSite = options.sameSite ?? "Lax";

  const parts = [`${encodeURIComponent(name)}=${encodeURIComponent(value)}`, `Path=${path}`];

  if (typeof options.maxAgeSeconds === "number") {
    parts.push(`Max-Age=${options.maxAgeSeconds}`);
  }
  if (options.secure) {
    parts.push("Secure");
  }
  if (sameSite) {
    parts.push(`SameSite=${sameSite}`);
  }

  document.cookie = parts.join("; ");
}
